import { TFunction } from "i18next";
import { Select, InputText, Text } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";

import { IconChevronDown } from "@pentabd/icons";
import { getConvertedMetaDataForEmployee } from "@helpers/inventory/metaDataConvert";

export const AddTagModalTableColumn = (
  t: TFunction<"translation", undefined>,
  room: any,
  setRoom: (id: number | string, value: number | string, name: string) => void,
  type: number,
) => {
  const { language } = useLanguage();
  return [
    {
      id: 1,
      key: "name",
      name: t("PROCUREMENTS_DETAILS.ADD_TAG_MODAL.TABLE.COLUMN.PRODUCT_NAME"),
      render: (_: string, row: any) => {
        const name = language === "bn" ? row.nameBn : row.nameEn;
        return <Text color="subtitle1">{name}</Text>;
      },
    },
    {
      id: 2,
      key: "room",
      name: t("PROCUREMENTS_DETAILS.ADD_TAG_MODAL.TABLE.COLUMN.STORE_ROOM"),
      render: (_: any, row: any) => {
        return (
          <div>
            <Select
              name="room"
              options={getConvertedMetaDataForEmployee(room, language)}
              onSelectItem={(value) => {
                setRoom(row.id, Number(value), "room");
              }}
              suffix={<IconChevronDown size="16" />}
              placeholder={t(
                "PROCUREMENTS_DETAILS.ADD_TAG_MODAL.FORM.FIELD_3.PLACEHOLDER",
              )}
            />
          </div>
        );
      },
    },
    {
      id: 3,
      key: "serialNo",
      name:
        type === 1 &&
        t("PROCUREMENTS_DETAILS.ADD_TAG_MODAL.TABLE.COLUMN.TAG_NO"),
      render: (_: any, row: any) => {
        if (type === 1) {
          return (
            <InputText
              name="serialNo"
              onChange={(e) => {
                setRoom(row.id, e.target.value, "serialNo");
              }}
              size="sm"
              placeholder="Enter Serial No"
              type="string"
              controlling
            />
          );
        }
      },
    },
  ];
};
